import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsGoogleComponent } from './simple-icons-google.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsGoogleComponent ],
    exports:      [ SimpleIconsGoogleComponent ],
    bootstrap:    []
})
export class SimpleIconsGoogleModule {}
